export enum ProductCategoryMacroTypeEnum {

  Generic = 1,
  Event = 10,
  Merchandising = 15,
  Subscription = 20

}
